import { Button, ButtonProps, useColorMode } from '@chakra-ui/react';

export default function CanopyButton({
    children,
    fontSize = 'lg',
    ...props
}: ButtonProps) {
    const { colorMode } = useColorMode();
    return (
        <Button
            height="35px"
            borderRadius="4px"
            colorScheme={colorMode + 'Primary'}
            fontSize={fontSize}
            {...props}>
            {children}
        </Button>
    );
}
